
// @ts-ignore
    import __i18nConfig from '@next-translate-root/i18n'
// @ts-ignore
    import __loadNamespaces from 'next-translate/loadNamespaces'
// @ts-ignore
    
import { NextSeo } from 'next-seo'
import useTranslation from 'next-translate/useTranslation'
import { useState } from 'react'
import SearchInput from '@/components/SearchInput'
import CarFormLabel from '@/domains/car/components/CarForm/CarFormLabel'
import CarFormProgress from '@/domains/car/components/CarForm/CarFormProgress'
import CarFormStep from '@/domains/car/components/CarForm/CarFormStep'
import Option from '@/domains/car/components/CarForm/Option'
import carMakes, {
  topCarMakes,
} from '@/domains/car/components/CarForm/carMakes'
import {
  useParsePayoutAmount,
  useRedirectOnParseError,
} from '@/domains/car/helpers/parseCarFormQuery'
import { createGetServerSideProps } from '@/helpers/createGetServerSideProps'
import { useSearchParams } from '@/helpers/useSearchParams'
import { cn } from '@/utils/cn'

export default function CarFormMakeStep() {
  const { t } = useTranslation('carPawnFormMakeStep')

  const queryParams = useSearchParams()
  const [searchTerm, setSearchTerm] = useState('')

  const parsePayoutAmountResult = useParsePayoutAmount()

  useRedirectOnParseError(parsePayoutAmountResult)

  const searchValue = searchTerm.toLowerCase()
  const filteredMakes = carMakes.filter(
    (m) =>
      m.name.toLowerCase().includes(searchValue) ||
      ('alias' in m && m.alias.toLowerCase().includes(searchValue)),
  )

  const isSearching = searchTerm !== ''
  return (
    <CarFormStep step={1}>
      <NextSeo noindex nofollow title={t('title')} />

      <div>
        <CarFormProgress step={1} />

        <h1 className="text-heading-m text-primary text-center my-2">
          {t('pick_make')}
        </h1>
      </div>

      <SearchInput
        label={t('search_makes')}
        value={searchTerm}
        onChange={(event) => setSearchTerm(event.target.value)}
        onClearClick={() => setSearchTerm('')}
        className="shrink-0"
      />

      <section
        className={cn(
          'transition-all',
          isSearching
            ? 'max-h-0 opacity-0 overflow-hidden'
            : 'max-h-screen opacity-100',
        )}
      >
        <CarFormLabel>{t('frequently_searched_makes')}</CarFormLabel>
        <div className="grid grid-cols-3 grid-rows-3 gap-2">
          {topCarMakes.map((make) => (
            <Option
              href={{
                pathname: '/autopfand-formular/modell',
                query: { ...queryParams, marke: make.name },
              }}
              className="input-border h-20 rounded-xl bg-static-white"
              key={make.name}
              tabIndex={isSearching ? -1 : undefined}
            >
              <make.Icon className="size-12 m-auto" />
            </Option>
          ))}
        </div>
      </section>

      <section>
        <CarFormLabel>
          {!isSearching
            ? t('all_makes')
            : filteredMakes.length > 0
              ? t('matching_makes')
              : t('no_matching_makes', { searchTerm })}
        </CarFormLabel>
        <ul className="flex flex-col gap-2">
          {filteredMakes.map((make) => (
            <Option
              href={{
                pathname: '/autopfand-formular/modell',
                query: { ...queryParams, marke: make.name },
              }}
              key={make.name}
            >
              {/* <make.Icon className="size-6" /> */} {make.name}
            </Option>
          ))}
        </ul>
      </section>
    </CarFormStep>
  )
}

 const _getServerSideProps = createGetServerSideProps()


// @ts-ignore
    export async function getServerSideProps(ctx) {
// @ts-ignore
        let res = _getServerSideProps(ctx)
// @ts-ignore
        if(typeof res.then === 'function') res = await res
// @ts-ignore
        return {
// @ts-ignore
          
// @ts-ignore
          ...res,
// @ts-ignore
          props: {
// @ts-ignore
            ...(res.props || {}),
// @ts-ignore
            ...(await __loadNamespaces({
// @ts-ignore
              ...ctx,
// @ts-ignore
              pathname: '/autopfand-formular/index',
// @ts-ignore
              loaderName: 'getServerSideProps',
// @ts-ignore
              ...__i18nConfig,
// @ts-ignore
              
// @ts-ignore
            }))
// @ts-ignore
          }
// @ts-ignore
        }
// @ts-ignore
    }
// @ts-ignore
  